export default __webpack_public_path__ + "static/media/step4.d87c8f36.svg";